import Metamask from "./WalletIcons/metamaskWallet.png";
import WalletConnect from "./WalletIcons/wallet-connect.svg";
import TrustWallet from "./WalletIcons/TrustWallet.png";

export const connectors = [
    {
        title: "Metamask",
        icon: Metamask,
        connectorId: "injected",
        priority: 1,
        badge: "Popular",
    },
    {
        title: "WalletConnect",
        icon: WalletConnect,
        connectorId: "walletconnect",
        priority: 2,
        badge: "Best for Mobile",
    },
    {
        title: "Trust Wallet",
        icon: TrustWallet,
        connectorId: "injected",
        priority: 3,
    },
];

export const networks = {
    eth_main: "https://mainnet.infura.io/v3/7d9d43def2584f2a9f01f2a4719327bc",
    eth_test: "https://ropsten.infura.io/v3/8ca77c4631f14dccb88318200cfca61d",
    bsc_main: "https://bsc-dataseed.binance.org/",
    bsc_test: "https://data-seed-prebsc-2-s3.binance.org:8545",
};
